import {PaymentResult} from "./payment-result";

export default PaymentResult